import React, { useState, useEffect } from 'react';
import { useParams} from 'react-router-dom';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import Overview from '../../components/event/Overview';
import InfoEvent from '../../components/event/InfoEvent';
import Logistics from '../../components/event/Logistics';
import eventService from '../../services/EventService';

export default function EventDetail({ itemsPerPage = 10 }) {
    const { id } = useParams();
    const [event, setEvent] = useState(null);
    const [activeTab, setActiveTab] = useState('overview');

    const fetchEvent= async (id) => {
        try {
            const res = await eventService.getEvent(id);
            setEvent(res.data);
        } catch (error) {
            console.error('Error fetching event', error);
        }
    }
    useEffect(() => {
        fetchEvent(id);
    }, [id]);

    if (!event) {
        return <p>Caricamento...</p>;
    }
    // Funzione per gestire il click sui tab
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

  	return (
        <>
            <div className="row">
                {/* Detail Sidebar */}
                <div className="col-xl-4 col-lg-5 col-md-5 order-1 order-md-0">
                    <div className="card mb-6">
                        <div className="card-body pt-12">
                            <div className="customer-avatar-section">
                                <div className="d-flex align-items-center flex-column">
                                    <div className="avatar">
                                        <div className="avatar-initial rounded bg-label-primary">
                                            <i className="bx bxl-play-store bx-lg"></i>
                                        </div>
                                    </div>
                                    <div className="customer-info text-center mb-6">
                                        <h5 className="mb-0">{event.name}</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="info-container">
                                <h5 className="pb-4 border-bottom text-capitalize mt-6 mb-4">Dettaglio</h5>
                                <ul className="list-unstyled mb-6">
                                   <li className="mb-2">
                                        <span className="h6 me-1">Anno:</span>
                                        <span>{event.year}</span>
                                    </li>
                                    <li className="mb-2">
                                        <span className="h6 me-1">Indirizzo:</span>
                                        <span>{event.address ? event.address : 'Non inserito'}</span>
                                    </li>
                                    <li className="mb-2">
                                        <span className="h6 me-1">Città:</span>
                                        <span>{event.city ? event.city : 'Non inserita'}</span>
                                    </li>
                                    <li className="mb-2">
                                        <span className="h6 me-1">Inizio:</span>
                                        <span>{event.startDate ? format(new Date(event.startDate), 'dd MMMM yyyy', { locale: it }) : 'Non inserita'}</span>
                                    </li>
                                    <li className="mb-2">
                                        <span className="h6 me-1">Fine:</span>
                                        <span>{event.endDate ? format(new Date(event.endDate), 'dd MMMM yyyy', { locale: it }) : 'Non inserita'}</span>
                                    </li>
                                    <li className="mb-2">
                                        <span className="h6 me-1">Ricorrenza:</span>
                                        {/* {event.recurrence ? event.recurrence : 'Non inserita'} non deve prendere il valore ma la label*/}
                                        <span>Da impostare</span>
                                    </li>
                                    <li className="mb-2">
                                        <span className="h6 me-1">Stato:</span>
                                        <span className={`badge me-1 ${event.status ? "bg-label-success" : "bg-label-danger"}`}>
                                            {event.status ? 'Attivo': 'Non Attivo'}
                                        </span>
                                    </li>
                                </ul>
                                <div className="d-flex justify-content-center">
                                    <a  className="btn btn-primary me-4">Modifica</a>
                                    {event.status && <a  className="btn btn-label-danger">Sospendi</a>}
                                    {!event.status && <a className="btn btn-label-success">Attiva</a>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /Detail Sidebar */}
                <div className="col-xl-8 col-lg-7 col-md-7 order-0 order-md-1">
                    {/* Nav eventDetail */}
                    <div className="nav-align-top">
                        <ul className="nav nav-pills flex-column flex-md-row mb-6">
                            <li className="nav-item">
                                <a onClick={() => handleTabClick('overview')}
                                    className={`nav-link ${activeTab === 'overview' ? 'active' : ''}`}>
                                    <i className="bx bx-calendar-event bx-sm me-1_5"></i>
                                    Panoramica
                                </a>
                            </li>
                            <li className="nav-item">
                                <a onClick={() => handleTabClick('info')}
                                    className={`nav-link ${activeTab === 'info' ? 'active' : ''}`}>
                                    <i className="bx bx-info-circle me-1_5 bx-md"></i>
                                    Informazioni
                                </a>
                            </li>
                            <li className="nav-item">
                                <a onClick={() => handleTabClick('logistics')}
                                    className={`nav-link ${activeTab === 'logistics' ? 'active' : ''}`}>
                                    <i className="bx bxs-truck me-1_5 bx-sm"></i>
                                    Date
                                </a>
                            </li>
                        </ul>
                    </div>
                    {/* /Nav eventDetail */}
                    {/* Event cards*/}
                    {activeTab === 'overview' && <Overview event={event} />}
                    {activeTab === 'info' && <InfoEvent event={event} />}
                    {activeTab === 'logistics' && <Logistics event={event} />}
                    {/* /Event cards  */}
                </div>
            </div>
        </>
	);
}